const moment = require("moment");

const getToken = () => {
    return localStorage.getItem('token') || null;
}

const getUserDetail = () => {
    return JSON.parse(localStorage.getItem('user_detail'));
}

const getUserId = () => {
    return (localStorage.getItem('user_detail')) ? JSON.parse(localStorage.getItem('user_detail'))['userId'] : 0;
}

const getUserType = () => {
    if (localStorage.getItem('user_detail')) {
        return JSON.parse(localStorage.getItem('user_detail'))['userRole'];
    } else {
        return 0;
    }
}

const removeUserSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_detail');
}

const setUserSession = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user_detail', JSON.stringify(user));
}

const is_login = () => {
    if (localStorage.getItem('token')) {
        return true;
    } else {
        return false;
    }
}

const amountFormat = (amount, showIcon = true) => {
    if(showIcon){
        return '£'+parseFloat(amount).toFixed(2);
    }else{
        return parseFloat(amount).toFixed(2);
    }
}

const Date_format = (date) => {
    var dateNew = new Date(date),
        mnth = ("0" + (dateNew.getMonth() + 1)).slice(-2),
        day = ("0" + dateNew.getDate()).slice(-2);
    return  [dateNew.getFullYear(), mnth, day].join("-");
}


const IsModemAccess = (modem_name,type) => {
    return true;
    // var modem = JSON.parse(localStorage.getItem('user_detail'))?.['roleAssigned'];
    // if(modem && modem[modem_name] && modem[modem_name].module[type] === 1){
    //     return true;
    // }else{
    //     return false;
    // }
}

const utc_local = (data_time,format ="DD/MM/YYYY HH:mm:ss") => {
    if(data_time){
        return moment.utc(data_time).local().format(format);
    }else{
        return '';
    }
}

const get_order_status_color = (status) => {
    status = (status)? status.toLowerCase() : '';
    if(status === 'pending'){
        return 'bg-pending';
    } else if(status === 'order placed'){
        return 'bg-order-placed';
    }else if(status === 'Order Confirmed'){
        return 'bg-order-confirmed';
    }else if(status === 'on hold'){
        return 'bg-on-hold';
    }else if(status === 'in review'){
        return 'bg-in-review';
    }else if(status === 'packed'){
        return 'bg-packed';
    }else if(status === 'shipped'){
        return 'bg-shipped';
    }else if(status === 'out for delivery'){
        return 'bg-out-for-delivery';
    }else if(status === 'delivered'){
        return 'bg-delivered';
    }else if(status === 'cancelled'){
        return 'bg-cancelled';
    }else if(status === 'returned'){
        return 'bg-returned';
    }else if(status === 'refunded'){
        return 'bg-refunded';
    }else {
        return 'bg-info';
    }
}

const payment_status_color = (status) => {
    status = (status)? status.toLowerCase() : '';
    if(status === 'paid'){
        return 'bg-delivered';
    }else if(status === 'unpaid'){
        return 'bg-out-for-delivery';
    }else if(status === 'processing'){
        return 'bg-pending';
    } else if(status === 'Cancelled'){
        return 'bg-cancelled';
    }else {
        return 'bg-info';
    }
}

const get_smm_order_status_color = (status) => {
    status = status.toLowerCase();

    if(status === 'On-Hold'){
        return 'bg-on-hold';
    }if(status === 'pending'){
        return 'bg-pending';
    }else if(status === 'failed' || status === 'cancelled' || status === 'canceled' || status === 'partial'){
        return 'bg-cancelled';
    }else if(status === 'processing'){
        return 'bg-processing';
    }else if(status === 'in progress'){
        return 'bg-in-process';
    }else if(status === 'completed'){
        return 'bg-success';
    }else if(status === 'refunded'){
        return 'bg-secondary';
    }else {
        return 'bg-primary';
    }
}
export {get_smm_order_status_color,payment_status_color, get_order_status_color, utc_local, IsModemAccess, Date_format, amountFormat, getUserType, getToken, removeUserSession, setUserSession, is_login, getUserDetail, getUserId };